var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForInternationalBusinesses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.99 66.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.21,12.75a23.91,23.91,0,0,0-3.28-.26h0a23.91,23.91,0,0,0-3.28.26A22,22,0,0,0,1,33.73c.05,1.88.75,7.38,6.7,14.48h0L22.92,66.39,38.16,48.21c6-7.1,6.65-12.6,6.7-14.48A22,22,0,0,0,26.21,12.75ZM30.5,34.83A7.89,7.89,0,0,1,15,32.68a7.67,7.67,0,0,1,.79-3.39,7.89,7.89,0,0,1,3.8-3.74,7.57,7.57,0,0,1,3.3-.7,7.56,7.56,0,0,1,3.29.7A7.85,7.85,0,0,1,30,29.29a7.67,7.67,0,0,1,.79,3.39A7.82,7.82,0,0,1,30.5,34.83Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.54,
    cy: 44.26,
    r: 22.15,
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "For International Businesses") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.22,12.75a24,24,0,0,0-3.28-.26h0a24.16,24.16,0,0,0-3.28.26A22,22,0,0,0,0,33.73c.05,1.88.75,7.38,6.69,14.48h0L21.93,66.39,37.17,48.21c5.95-7.1,6.65-12.6,6.69-14.48A22,22,0,0,0,25.22,12.75Zm4.29,22.08a7.9,7.9,0,0,1-15.15,0,7.45,7.45,0,0,1-.31-2.15,7.67,7.67,0,0,1,.79-3.39,7.87,7.87,0,0,1,3.79-3.74,7.57,7.57,0,0,1,3.3-.7,7.57,7.57,0,0,1,3.3.7A7.87,7.87,0,0,1,29,29.29a7.54,7.54,0,0,1,.8,3.39A8.21,8.21,0,0,1,29.51,34.83Z",
    style: {
      fill: "#bddef4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.21,12.75a23.91,23.91,0,0,0-3.28-.26h0a23.91,23.91,0,0,0-3.28.26A22,22,0,0,0,1,33.73c.05,1.88.75,7.38,6.7,14.48h0L22.92,66.39,38.16,48.21c6-7.1,6.65-12.6,6.7-14.48A22,22,0,0,0,26.21,12.75ZM30.5,34.83A7.89,7.89,0,0,1,15,32.68a7.67,7.67,0,0,1,.79-3.39,7.89,7.89,0,0,1,3.8-3.74,7.57,7.57,0,0,1,3.3-.7,7.56,7.56,0,0,1,3.29.7A7.85,7.85,0,0,1,30,29.29a7.67,7.67,0,0,1,.79,3.39A7.82,7.82,0,0,1,30.5,34.83Z",
    style: {
      fill: "#dcf6ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.77,29.82a26.33,26.33,0,1,0,0,37.26A26.39,26.39,0,0,0,70.77,29.82Z",
    style: {
      fill: "#bddef4"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.94,
    y: 7.12,
    width: 6.83,
    height: 3.23,
    style: {
      fill: "#9fffb3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.94,
    y: 10.36,
    width: 6.83,
    height: 3.44,
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.77,
    y: 7.12,
    width: 6.83,
    height: 3.23,
    style: {
      fill: "#9fffb3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.77,
    y: 10.36,
    width: 6.83,
    height: 3.44,
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.94,
    y1: 66.49,
    x2: 56.94,
    y2: 7.12,
    style: {
      fill: "none",
      stroke: "#dcf6ff",
      strokeMiterlimit: 10,
      strokeWidth: "0.81942427729107px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.39,44.22A22.15,22.15,0,0,0,69.2,59.92L37.88,28.59A22.08,22.08,0,0,0,31.39,44.22Z",
    style: {
      fill: "#dcf6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54,22.11a22.14,22.14,0,0,0-15.66,6.48L69.2,59.92A22.16,22.16,0,0,0,53.54,22.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.39,44.22A22.15,22.15,0,0,0,69.2,59.92L37.88,28.59A22.08,22.08,0,0,0,31.39,44.22Z",
    style: {
      fill: "#dcf6ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,37.79l-.45.64-1.12.64-.45,1-1,.24-1.45,2,.06,1L41,44.74l1.13,3,1.57,1.4,1.21-.09s1.18.34,1.18.34,1.92-.55,2-.54A16.22,16.22,0,0,1,49.39,50h1.09l-.4,2,2.14,3.79-.7,1.38,1.37,2.33v.91l1.21.86-.27.58.39.38L56.37,62l2.56-1.2.41-1,1-.39V57.86l2.22-1.49L62,53.24l3.33-4.05.79-3L66,45.87,63.78,47l-.49-.34.12-.36L62,45.23,61.58,44,61,43.4l-.88-1.26L59,40.78h.59l2.14,2.12,2.08,3.24,1-.63,1-.72.61-1,.88-.58.48-1.72-1.29-.74-.73.82L64,39.94l.75-.17,1.11.74.9-.25.54.38,2.21-.53,1.65.62,2.09,4.58L74,44,73.47,42l.5-1.3-.06-1.2.45-.9.78.91,3-.27-5.7-10.83L60.75,22.11l-1.31,1.24,1.83,2.09-.36.78-1.6.12-.75-1.82-.9.35,1,2.26-1,.05-3.2-.11-1.4.95-1.54,1.15-.72.9.83.7-1,.41-.56,1.06-1.2.84h-1l.45.63-.51,1.22-1.15-.23-.85.62L45.31,37l2,.13,1.74-1,.66-1L51.47,35l.21.49,1.17.93-.64,1.22.73.35,1-1.28-.64-1.47,1.2-.23-.09,1.13s.15,1.09.38,1.23.87.62.87.62l.89-1.49.36,1.25,1.31.67,1.59-.77.08.72-.22,1-1,.49-3.41-.36-1.34.27-.34.7L52,39.86l-.63-1.22.07-.88-2.09-.45-1.46.55Z",
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4,55l-1.12,1.25-.5.24-.44.48.2.66-.24.59-.34.38a3.55,3.55,0,0,0,.08.73l.94.19.81-1.85.6-1.38.37-.26-.1-.85Z",
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.39,40.24a14.88,14.88,0,0,1,.83,1.46c0,.11-.1,1.5-.11,1.5s0,.71,0,.71l.77,1.22.17,1.11a5.66,5.66,0,0,0-.22,1.16,10.46,10.46,0,0,1,.74.75l.85,1.06,1.12,1.08.35.68.08.81-.32,1-.13.54.24,1V55l.25.78h-.9l.41.77.18.53-.11.88-8.1-4.15,1-8.6Z",
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.55,31l.16.21.68-.52h.33l.37-.64.73-.22-.51.36v.25l.31.18.46-.39.28-.41-.14-.37.51-.41.43-.24-.42-.35.59-.16a3.07,3.07,0,0,0,.17.31c0,.1.78,0,.78,0l-1.57,1-.05.4.33.61.94-.79v-.59l.35-.37.68-.41.14-.82.35-.64.28-.34-.2-.3L42,26l.57-.4L42.4,25l-1.61-.86L35.91,28Z",
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.77,27.4l2.3-1.94.63-.35,1.19-.69,1.19-.7-.18-.19.45-.22-.25-.07.08-.37-.44.09v.28l-.75.18-.2-.53,2-1.19a3.89,3.89,0,0,1,1,.41,3.11,3.11,0,0,1-.21.85l-.51.66.47.34v-.17l1.3.06.18.2-.22.39.54.15-.1.24a5.68,5.68,0,0,0-1,0,2.9,2.9,0,0,0-.2.87L49,26s-.16-.34-.24-.26a3.64,3.64,0,0,0-.38.66l-.5.17-1.27-.29-1,.38-.4-.17-.69.86-1.3.57Z",
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.66,26.81c0,.13-.55.35-.55.35L47,27.5l-.43.06V28l.59.22,1-.26.59-.33-.12-.48s0-.28-.13-.21a.59.59,0,0,1-.32.06L48,26.79Z",
    style: {
      fill: "#011b33"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 56.53,
    cy: 50.95,
    r: 1.11,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.93,
    cy: 35.84,
    r: 1.11,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.49,42.28a4.28,4.28,0,0,0,1.17-2.53,3.85,3.85,0,0,0-3.27-3.68,3.66,3.66,0,0,0-.57,0h0a3.66,3.66,0,0,0-.57,0A3.85,3.85,0,0,0,42,39.75a4.28,4.28,0,0,0,1.17,2.53h0l2.67,3.19h0l2.67-3.19Zm-1.35-2a1.38,1.38,0,0,1-2.65,0,1.21,1.21,0,0,1-.06-.38,1.31,1.31,0,0,1,.14-.59,1.39,1.39,0,0,1,.67-.66,1.27,1.27,0,0,1,.57-.12,1.29,1.29,0,0,1,.58.12,1.43,1.43,0,0,1,.67.66,1.31,1.31,0,0,1,.14.59A1.21,1.21,0,0,1,47.14,40.25Z",
    style: {
      fill: "#9fffb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.42,53.6a4.32,4.32,0,0,0,1.17-2.54,3.85,3.85,0,0,0-3.27-3.68,3.64,3.64,0,0,0-.57,0h0a3.64,3.64,0,0,0-.57,0,3.85,3.85,0,0,0-3.27,3.68,4.32,4.32,0,0,0,1.17,2.54h0l2.67,3.19h0l2.67-3.19Zm-1.35-2a1.38,1.38,0,0,1-2.65,0,1.21,1.21,0,0,1-.06-.38,1.38,1.38,0,0,1,.14-.59,1.33,1.33,0,0,1,.67-.65,1.28,1.28,0,0,1,.57-.13,1.33,1.33,0,0,1,.58.13,1.37,1.37,0,0,1,.67.65,1.38,1.38,0,0,1,.14.59A1.21,1.21,0,0,1,58.07,51.56Z",
    style: {
      fill: "#9fffb3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.72,33.71a4.32,4.32,0,0,0,1.17-2.54,3.85,3.85,0,0,0-3.27-3.68,3.64,3.64,0,0,0-.57,0h0a3.64,3.64,0,0,0-.57,0,3.85,3.85,0,0,0-3.27,3.68,4.32,4.32,0,0,0,1.17,2.54h0L64,36.9h0l2.67-3.19Zm-1.35-2a1.38,1.38,0,0,1-2.65,0,1.21,1.21,0,0,1-.06-.38,1.38,1.38,0,0,1,.14-.59,1.43,1.43,0,0,1,.67-.66,1.47,1.47,0,0,1,.58-.12,1.42,1.42,0,0,1,.57.12,1.4,1.4,0,0,1,.81,1.25A1.21,1.21,0,0,1,65.37,31.67Z",
    style: {
      fill: "#9fffb3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.43,
    y1: 66.01,
    x2: 81.85,
    y2: 66.01,
    style: {
      fill: "none",
      stroke: "#dcf6ff",
      strokeMiterlimit: 10,
      strokeWidth: "0.81942427729107px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.41 18.38 78.41 20.02 78.41 21.66 78.41 23.3 78.41 24.94 82.97 24.94 82.97 23.3 82.97 21.66 82.97 20.02 82.97 18.38 78.41 18.38",
    style: {
      fill: "#f6fcff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.97 18.38 82.97 21.66 82.97 24.94 87.52 24.94 87.52 21.66 87.52 18.38 82.97 18.38",
    style: {
      fill: "#00e1ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.52 18.38 87.52 21.66 87.52 24.94 92.07 24.94 92.07 21.66 92.07 18.38 87.52 18.38",
    style: {
      fill: "#011b33"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.41,
    y1: 66.49,
    x2: 78.41,
    y2: 18.38,
    style: {
      fill: "none",
      stroke: "#dcf6ff",
      strokeMiterlimit: 10,
      strokeWidth: "0.81942427729107px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForInternationalBusinesses);
export default __webpack_public_path__ + "static/media/For-International-Businesses.f5f7982e782a22bbdb18e307e87c6330.svg";
export { ForwardRef as ReactComponent };